import { trackEvent } from '~/utils/analytics'

const MAX_MESSAGE_LENGTH = 255
const MAX_STACK_LENGTH = 600

const trimValue = (value?: string | null, maxLength = MAX_MESSAGE_LENGTH) => {
  if (!value) return ''
  return value.slice(0, maxLength)
}

const getErrorPayload = (error: unknown) => {
  if (error instanceof Error) {
    return {
      error_name: trimValue(error.name),
      error_message: trimValue(error.message),
      error_stack: trimValue(error.stack, MAX_STACK_LENGTH),
    }
  }

  return {
    error_name: 'NonError',
    error_message: trimValue(String(error)),
    error_stack: '',
  }
}

export default defineNuxtPlugin(() => {
  const reportedKeys = new Set<string>()

  const reportClientError = (eventName: string, payload: Record<string, any>) => {
    const key = [
      eventName,
      payload.error_message,
      payload.source_file,
      payload.line_no,
      payload.column_no,
    ].join('|')

    if (reportedKeys.has(key)) return
    reportedKeys.add(key)

    if (reportedKeys.size > 50) {
      const firstKey = reportedKeys.values().next().value
      if (firstKey) reportedKeys.delete(firstKey)
    }

    trackEvent(eventName, {
      source: 'client_error',
      page_path: window.location.pathname,
      page_url: window.location.href,
      user_agent: trimValue(navigator.userAgent),
      ...payload,
    })
  }

  window.addEventListener('error', (event) => {
    reportClientError('client_js_error', {
      ...getErrorPayload(event.error || event.message),
      source_file: trimValue(event.filename),
      line_no: event.lineno || 0,
      column_no: event.colno || 0,
    })
  })

  window.addEventListener('unhandledrejection', (event) => {
    reportClientError('client_unhandled_rejection', {
      ...getErrorPayload(event.reason),
      source_file: '',
      line_no: 0,
      column_no: 0,
    })
  })
})
